import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseComponent } from '../base/base.component';
import { HandleRouteComponent } from '../base/handle-route.component';
const routes: Routes = [
  { path: '**', component: HandleRouteComponent },
  {
    path: '',
    data: { type: '' },
    component: BaseComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChatBotRoutingModule { }